import { jsx as e } from "react/jsx-runtime";
function r(l) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 24 24", width: "1em", ...l, children: /* @__PURE__ */ e(
    "path",
    {
      d: "M12 10.545l5.818-5.818a1.03 1.03 0 011.455 0 1.03 1.03 0 010 1.455L13.455 12l5.818 5.818a1.03 1.03 0 010 1.455 1.03 1.03 0 01-1.455 0L12 13.455l-5.818 5.818a1.03 1.03 0 01-1.455 0 1.03 1.03 0 010-1.455L10.545 12 4.727 6.182a1.03 1.03 0 010-1.455 1.03 1.03 0 011.455 0L12 10.545z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ) });
}
export {
  r as default
};
